import Modal from './Modal'

export default class {
  constructor() {

    const domModal = document.querySelector('[data-js="modal"]');
    if (domModal) new Modal(domModal);
  }
}
